import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import BoardOfAdvisors from "@/pages/BoardOfAdvisors";

export const Route = createFileRoute("/zh-cn/about-qbd/board-of-advisors")({
  head: () => buildRouteHead("/zh-cn/about-qbd/board-of-advisors"),
  component: BoardOfAdvisors,
});

